// Saisie JS de la date de naissance (pas de date picker natif → aucun rebuild EAS).
// Masque « JJ/MM/AAAA » + validation → ISO 'YYYY-MM-DD'.

// Aligné sur les CGU (15 ans minimum, RGPD art. 8 ; TermsScreen). Vérifié avant de relever le seuil
// le 03/10/2026 : aucun compte existant sous 15 ans.
const MIN_AGE = 15;
const MAX_AGE = 100;

// Formate la saisie brute en JJ/MM/AAAA au fil de la frappe (ne garde que les chiffres).
export function maskBirthDate(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean);
  return parts.join('/');
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function ageAt(year: number, month: number, day: number, now: Date): number {
  let age = now.getUTCFullYear() - year;
  const beforeBirthday =
    now.getUTCMonth() + 1 < month ||
    (now.getUTCMonth() + 1 === month && now.getUTCDate() < day);
  if (beforeBirthday) age -= 1;
  return age;
}

export type BirthDateResult = { iso: string } | { error: string };

// Valide une saisie JJ/MM/AAAA et renvoie l'ISO, ou une erreur explicite.
export function parseBirthDate(input: string, now: Date = new Date()): BirthDateResult {
  const match = input.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return { error: 'Format attendu : JJ/MM/AAAA.' };

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);

  // Vérifie que la date existe réellement (rejette 31/02, 00/13, etc.).
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return { error: 'Date invalide.' };
  }

  const age = ageAt(year, month, day, now);
  if (age < MIN_AGE || age > MAX_AGE) {
    return { error: 'Vérifie ta date de naissance.' };
  }

  return { iso: `${year}-${pad(month)}-${pad(day)}` };
}
